import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import CustomContainer from '../../components/common/CustomContainer'
import { useNavigate } from 'react-router-dom'
import styles from "../../assets/styles/labtest.module.css"
import { useDownloadExcel } from 'react-export-table-to-excel';
import { getFirstAidListApi } from '../../utils/api/services'
import { toast } from 'react-toastify'
import moment from 'moment'
import FirstAidTable from '../../components/firstaid/FirstAidTable';
import { useModuleAccess } from '../../components/hooks/useModuleAccess';
import allModules from '../../utils/functions/modules';

const FirstAid = () => {
    const [searchValue, setSearchValue] = useState('')
    const [filterValue, setFilterValue] = useState<FilterTypes>({
        fromDate: null,
        toDate: null
    })
    const [loading, setLoading] = useState(false)
    const [listData, setListData] = useState<FirstAidListTypes[] | []>([])
    const { canEdit } = useModuleAccess(allModules.FirstAid);
    const navigate = useNavigate();
    const tableRef = useRef<HTMLTableElement>(null);
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'First Aid',
        sheet: 'list'
    })

    const handleDateChange = (value: Date | null, name: string) => {
        const momentValue = value !== null ? moment(value)?.format('DD-MM-YYYY') : null;
        setFilterValue({
            ...filterValue,
            [name]: momentValue
        })
    }
    const handleSearchValue = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
    }
    const fetchTrainingData = async (data?: { searchQuery?: string, fromDate?: Date | null, toDate: Date | null }) => {
        try {
            setLoading(true)
            const result = await getFirstAidListApi(data);
            if (result?.success) {
                setLoading(false)
                setListData(result?.firstAidDetails)
            }
            else {
                setLoading(false)
                setListData([])
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (searchValue) {
            const cleanUpFun = setTimeout(() => {
                fetchTrainingData({ searchQuery: searchValue, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
            }, 1000);
            return () => clearInterval(cleanUpFun)
        }
        else {
            fetchTrainingData({ searchQuery: searchValue ? searchValue : undefined, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
        }
    }, [searchValue, filterValue]);

    return (
        <CustomContainer>
            <div className='AllPageMain'>
                <div className='HeadAndButton'>
                    <h2>First Aid check list</h2>
                    <div className='flex items-center gap-6'>
                        {
                            canEdit &&
                            <button className='fillButton' onClick={() => navigate('/firstaid/add')}>New Entry +</button>
                        }
                        <button className='outLineBtn' onClick={onDownload}>Export Data</button>
                    </div>
                </div>
                <div className={styles.labTestMain}>
                    <FirstAidTable
                        listData={listData}
                        loading={loading}
                        searchValue={searchValue}
                        ref={tableRef}
                        handleSearchValue={handleSearchValue}
                        filterValue={filterValue}
                        handleDateChange={handleDateChange}
                    />
                </div>
            </div>
        </CustomContainer>
    )
}

export default FirstAid